/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption } from 'reactstrap';

// context imports
import { AuthContext } from '../../contexts/AuthContext';
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import GeneralNavbar from './GeneralNavbar';
import Footer from './Footer';
import Blooming from '../../assets/blooming.svg'
import GiftCard from '../../assets/giftCard.svg'
// import PhoneChat from '../../assets/phoneChat.svg'
import GainLife from '../../assets/gainLife.svg'
import FindCounsellor from '../../assets/findCounsellor.svg'
import Chat from '../../assets/chat.svg'
import DownArrow from '../../assets/downArrow.svg';
import ChatSVG from '../../assets/undraw_messaging.svg';
import CallSVG from '../../assets/undraw_night_calls.svg';
import VideoSVG from '../../assets/undraw_group_video.svg';
import DemoSVG from '../../assets/undraw_product_explainer.svg';

import './Home.css';

// Manage chats, Messaging, Night calls, Video call, Group video, Remote meeting, Product explainer

const NewHome = (props) => {

    const subscriptionItems = [{
        src: ChatSVG,
        altText: '24/7 Chat',
        caption: 'Get access to 24/7 chat from your device',
        key: 1,
    }, {
        src: CallSVG,
        altText: 'Voice Call',
        caption: 'Enjoy bundled Voice Call sessions',
        key: 2,
    }, {
        src: VideoSVG,
        altText: 'Video Call',
        caption: 'Enjoy bundled Video Call sessions',
        key: 3,
    }];

    // context
    const { isAuthenticated, setIsAuthenticated, user, setUser } = useContext(AuthContext);
    const { theme, fontFamily, colors } = useContext(ThemeContext);

    // states
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const [textStyle, setTextStyle] = useState(theme.homeTitle);
    const [showScrollDown, setShowScrollDown] = useState(true);
    const [providersOnHome, setProvidersOnHome] = useState([]);

    // useEffects
    useEffect(() => {
        GeneralService.getProvidersOnHome().then(data => {
            setProvidersOnHome(data.providers);
        })
    }, [])

    // utility functions
    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === subscriptionItems.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? subscriptionItems.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const checkScrollDown = () => {
        let maxScroll = document.body.scrollHeight - window.innerHeight;
        if (!showScrollDown && window.pageYOffset < (maxScroll - 150)) {
            setShowScrollDown(true)
        } else if (showScrollDown && window.pageYOffset > (maxScroll - 150)) {
            setShowScrollDown(false)
        }
    };

    const scrollDown = () => {
        window.scrollTo({ top: window.pageYOffset + 250, behavior: 'smooth' });
    }

    window.addEventListener('scroll', checkScrollDown);

    const gotoGVPage = () => {
        try {
            if (window.confirm("By clicking on OK you will be redirected to RazorPay Payment page to buy GiftVoucher")) {
                if (window.location.host.includes("www.umangwellness.com")) {
                    window.location.href = "https://rzp.io/l/umangwellnessgift";
                } else {
                    window.location.href = "https://rzp.io/l/jkStIE8";
                }
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at General Home gotoGVPage', 'Error in try catch block', err.stack);
        }
    }

    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            <ErrorBoundary errorAt="At General Home GeneralNavbar">
                <GeneralNavbar history={props.history} />
            </ErrorBoundary>

            {/* Starting Section of Home Page */}
            <section className='px-3 pt-4 pb-5 border-bottom' id="hero-div">
                <div className="row" style={{ backgroundColor: "#fff" }}>
                    <div className="col-md-6 col-5 my-auto d-md-block d-none">
                        <h1 className="Headline" style={textStyle}>Online counselling for every mind.<br />Talk to us and heal yourself.</h1>
                        <Link to="/booksessionQuestionaire">
                            <button id="book-session-btn" className="btn HeadButton" style={theme.newHomeAction}>Book Now</button>
                        </Link>
                    </div>
                    <div className="col-md-4 col-9 ml-md-auto mr-md-0 mx-auto py-md-0">
                        <img style={{ maxHeight: "40rem", width: "100%" }} src={Blooming} alt="home-image" />
                    </div>
                    <div className="col-md-6 col-12 my-2 d-md-none text-center">
                        <h1 className="Headline my-2" style={textStyle}>Online counselling for every mind.<br />Talk to us and heal yourself.</h1>
                        <Link to="/booksessionQuestionaire">
                            <button id="book-session-btn" className="btn HeadButton mt-2" style={{ ...theme.newHomeAction, marginTop: 0 }}>Book Now</button>
                        </Link>
                    </div>
                </div>
            </section>

            {
                showScrollDown ? <div className="downArrowDiv"><img id="scrolldown-div" className="downArrowImg" src={DownArrow} onClick={scrollDown} /></div> : null
            }

            {/* how it works */}
            <section className='px-3 py-5 border-bottom' id="how-it-works-div">
                <div className="row" style={{ backgroundColor: "#fff" }}>
                    <h2 className="col-md-12 col-12 text-center" style={theme.newParagraphHeading} >How it works</h2>
                    <div className="col-md-12 col-12">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12 text-center">
                                <div>
                                    <img width="100%" height="300px" src={FindCounsellor} alt='find a counsellor' />
                                </div>
                                <div className='mt-2'>
                                    <h5>Find a counsellor that suits you.</h5>
                                    <p>Select a counsellor from our Expert Counsellors list. Get your first session for <em><b>free</b></em>.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 text-center">
                                <div>
                                    <img width="100%" height="300px" src={Chat} alt='find a counsellor' />
                                </div>
                                <div className='mt-2'>
                                    <h5>Consult using chat, call and video.</h5>
                                    <p>Book sessions with your Counsellor.<br /> OR <br />Buy Monthly Subscription to get bundled sessions.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 col-12 text-center">
                                <div>
                                    <img width="100%" height="300px" src={GainLife} alt='find a counsellor' />
                                </div>
                                <div className='mt-2'>
                                    <h5>Gain your life back!</h5>
                                    <p>Rejuvenate yourself, and lead a happy life.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Subscription */}
            <section className='px-3 py-5 border-bottom' id="subscription-div">
                <div className='row' style={{ backgroundColor: "#fff" }}>
                    <h2 className="col-md-12 col-12 text-center" style={theme.newParagraphHeading} >Subscriptions</h2>
                    <p className='col-12 text-center' style={{ marginTop: "1rem" }}>Subscribe to your Counsellor monthly and get access to unlimited 24x7 chat and bundled sessions at discounted rates.</p>
                    <Carousel
                        className='w-100'
                        activeIndex={activeIndex}
                        next={next}
                        previous={previous}
                        interval={3000}
                    // {...args}
                    >
                        <CarouselIndicators
                            className='customSubscriptionIndicators'
                            items={subscriptionItems}
                            activeIndex={activeIndex}
                            onClickHandler={goToIndex}
                        />
                        {
                            subscriptionItems.map((item, index) => (
                                <CarouselItem
                                    onExiting={() => setAnimating(true)}
                                    onExited={() => setAnimating(false)}
                                    key={item.src}
                                >
                                    <div className='row'>
                                        <div className='col-6 align-self-center'><h1 className="Headline" style={textStyle}>{item.caption}</h1></div>
                                        <img className='col-6' width="100%" height="300px" src={item.src} alt={item.altText} />
                                    </div>
                                </CarouselItem>
                            ))
                        }
                    </Carousel>
                    {/* <div className='col-md-12 col-12 d-flex text-center' style={{ overflow: 'auto' }}>
                        <img className="col-lg-3 col-md-4 col-6 my-md-0 my-2 px-1" style={{ maxHeight: "20rem", width: "100%" }} src={PhoneChat} alt="gift-image" />
                        <img className="col-lg-3 col-md-4 col-6 my-md-0 my-2 px-1" style={{ maxHeight: "20rem", width: "100%" }} src={PhoneChat} alt="gift-image" />
                        <img className="col-lg-3 col-md-4 col-6 my-md-0 my-2 px-1" style={{ maxHeight: "20rem", width: "100%" }} src={PhoneChat} alt="gift-image" />
                        <img className="col-lg-3 col-md-4 col-6 my-md-0 my-2 px-1" style={{ maxHeight: "20rem", width: "100%" }} src={PhoneChat} alt="gift-image" />
                    </div> */}
                    <div className='col-12 text-center'>
                        <Link to="/client/booksession">
                            <button className="btn HeadButton" style={{ ...theme.newHomeAction, marginTop: '1rem' }}>Start Subscription</button>
                        </Link>
                    </div>
                </div>
            </section>

            {/* meet our counsellor */}
            <section className='px-3 py-5 border-bottom' id="find-provider-div">
                <div className='row' style={{ backgroundColor: "#fff" }}>
                    <h2 className="col-md-12 col-12 text-center" style={theme.newParagraphHeading} >Meet our Counsellors</h2>
                    <p className='col-12 text-center'>All Counsellors at Umang Wellness are verified professionals. Browse our Counsellor list to select your counsellor.</p>
                    <div className='col-md-12 col-12 d-flex text-center' style={{ overflow: 'auto' }}>
                        {
                            providersOnHome.map((item, index) => (
                                <div key={index} className="col-lg-3 col-md-4 col-6 my-md-0 my-2 px-1">
                                    <div className="card" style={{ borderRadius: "20px", height: "25rem", maxHeight: "25rem" }}>
                                        <img className="card-img-top p-2" style={{ maxHeight: "18rem", width: "100%" }} src={item.profileImage} alt="Card image cap" />
                                        <div className="card-body">
                                            <h5 className="card-title">{item.title} {item.firstName} {item.lastName}</h5>
                                            <p className="card-text">{item.specialities.join(', ')}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className='col-12 text-center'>
                        <a href="/counsellors">
                            <button id="view-counsellors-btn" className="btn HeadButton" style={{ ...theme.newHomeAction, marginTop: '1rem' }}>View more</button>
                        </a>
                    </div>
                </div>
            </section>

            {/* Site demo */}
            <section id="siteDemo" className='px-3 py-5 border-bottom'>
                <div className="row" style={{ backgroundColor: "#fff" }}>
                    <h2 className="col-md-12 col-12 text-center" style={theme.newParagraphHeading} >Try Demo</h2>
                    <div className="col-md-6 col-12 my-auto d-md-block d-none">
                        <h1 className="Headline" style={textStyle}>Sign up to access demo of Umang Wellness.</h1>
                        <p>You can visit all features of Umang Wellness via this demo.</p>
                        <Link to="/demo/signupRequest">
                            <button className="btn HeadButton demoSignupBtn" style={{ ...theme.newHomeAction, marginTop: 0 }}>Signup</button>
                        </Link>
                    </div>
                    <div className="col-md-5 col-12 ml-auto d-flex">
                        <img className='my-auto' height="300px" widht="auto" src={DemoSVG} alt="demo-image" />
                    </div>
                    <div className="col-md-6 col-12 my-2 d-md-none text-center">
                        <h1 className="Headline" style={textStyle}>Sign up to access demo of Umang Wellness.</h1>
                        <p>You can visit all features of Umang Wellness via this demo.</p>
                        <Link to="/demo/signupRequest">
                            <button className="btn HeadButton demoSignupBtn" style={{ ...theme.newHomeAction, marginTop: 0 }}>Signup</button>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Gift Voucher */}
            <section id="giftVoucher" className='px-3 py-5'>
                <div className="row" style={{ backgroundColor: "#fff" }}>
                    <h2 className="col-md-12 col-12 text-center" style={theme.newParagraphHeading} >Gift Wellness</h2>
                    <div className="col-md-6 col-12 my-auto d-md-block d-none">
                        <h1 className="Headline" style={textStyle}>Give the gift of Umang Wellness Voucher.</h1>
                        <p>Therapy is one of the most meaningful gifts you can give to your friends and loved ones.</p>
                        <button className="btn HeadButton giftVoucherBtn" style={{ ...theme.newHomeAction, marginTop: 0 }} onClick={gotoGVPage}>Gift Voucher</button>
                    </div>
                    <div className="col-md-5 col-12 ml-auto d-flex">
                        <img className='my-auto' style={{ width: "100%" }} src={GiftCard} alt="gift-image" />
                    </div>
                    <div className="col-md-6 col-12 my-2 d-md-none text-center">
                        <h1 className="Headline" style={textStyle}>Give the gift of Umang Wellness Voucher.</h1>
                        <p>Therapy is one of the most meaningful gifts you can give to your friends and loved ones.</p>
                        <button className="btn HeadButton giftVoucherBtn" style={{ ...theme.newHomeAction, marginTop: 0 }} onClick={gotoGVPage}>Gift Voucher</button>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default NewHome